"use client"

/**
 * IntercomComponent - Landing page Intercom integration
 *
 * For landing pages (anonymous visitors):
 * - Loads Intercom lazily: 5 s after the page's load event, at a quiet moment
 *   (keeps its ~470 KB of script out of page load and away from taps)
 * - Shows facade button until loaded
 * - No user identification
 *
 * For authenticated app pages, use IntercomProvider in the app layout
 * with user data for proper identification.
 */

import { IntercomProvider, IntercomFacade } from "@/components/intercom"

export default function IntercomComponent() {
    return (
        <IntercomProvider
            loadOnIdle={true}
            idleTimeout={8000}
            deferAfterLoadMs={5000}
            hideDefaultLauncher={false}
        >
            <IntercomFacade />
        </IntercomProvider>
    )
}
